import { render, staticRenderFns } from "./systemKPI.vue?vue&type=template&id=379afbc3&scoped=true&"
import script from "./systemKPI.vue?vue&type=script&lang=js&"
export * from "./systemKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379afbc3",
  null
  
)

export default component.exports